






































import { Vue, Component } from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency.js";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import PreenrollmentCopyParagraphs from "@/employee/components/investments/drivewealth/PreenrollmentCopyParagraphs.vue";
import { Location } from "vue-router";
import * as RouteNames from "@/employee/route-names";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFdicStore } from "@/shared/store/fdic";

@Component({
  components: {
    GenericLoadingSpinner,
    PreenrollmentCopyParagraphs,
  }
})
export default class Investments extends Vue {
  formatCurrency = formatCurrency;

  custodianSettingsStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  userStore = useUserStore();
  fdicStore = useFdicStore();

  created () {
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.fdicStore.setForceHideFdic(true);
  }

  beforeDestroy () {
    this.fdicStore.setForceHideFdic(false);
  }

  get isLoaded () {
    return this.investmentThresholdStore.thresholdsLoaded && this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get hsaInvestmentThreshold (): any {
    return this.investmentThresholdStore.investmentThreshold(false);
  }

  get hsaInvestEnrollButtonDisabled (): boolean {
    return this.custodianSettingsStore.hsaInvestEnrollButtonDisabled;
  }

  onSkip () {
    this.$emit("complete");
  }

  get wizardStartLocation (): Location {
    return {
      name: RouteNames.OnboardingDrivewealthPreenrollment,
      params: { stepKey: "investments", step: 0 as any as string }
    };
  }
}
